//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ReportInputItem } from './ReportInputItem';
import { IReportCashCategoryIDsInputItem } from './IReportCashCategoryIDsInputItem';
import { IReportDateRangeInputItem } from './IReportDateRangeInputItem';
import { IReportWithAttachments } from './IReportWithAttachments';
import { RevenueAndExpenseReportBasis, RevenueAndExpenseReportDetailLevel, RevenueAndExpenseReportSortBy, ReportType } from './Enums';

export class ExpenseReportInputItem extends ReportInputItem implements IReportCashCategoryIDsInputItem, IReportDateRangeInputItem, IReportWithAttachments {
    StartDate: string = "1970-01-01T00:00:00";
    EndDate: string = "1970-01-01T00:00:00";
    Basis: RevenueAndExpenseReportBasis = RevenueAndExpenseReportBasis.Accrual;
    DetailLevel: RevenueAndExpenseReportDetailLevel = RevenueAndExpenseReportDetailLevel.Itemized;
    SortBy: RevenueAndExpenseReportSortBy = RevenueAndExpenseReportSortBy.Category;
    IncludeAttachments: boolean = false;
    PayeeNames: string[] = [];
    CashCategoryIDs: string[] = [];
    override readonly Type: ReportType = ReportType.ExpenseReport;

    constructor(initializer?: Partial<Omit<ExpenseReportInputItem, "Type">>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static override readonly ClassName: string = "ExpenseReportInputItem";
}
